import { ITags } from "@formant/core/model/ITags";
import { Uuid } from "@formant/core/model/Uuid";

export interface IValueTooltip {
    x: number;
    y: number;
    time?: Date;
    value?: TooltipValue;
    deviceId: Uuid;
    tags: ITags;
    color?: string;
    cpu?: number;
    memory?: number;
    disk?: number;
}

export interface INumericTooltipValue {
    type: "numeric";
    average: number;
    minimum: number;
    maximum: number;
}

export interface ILocationTooltipValue {
    type: "location" | "location-overview";
    latitude: number;
    longitude: number;
}

export interface IBooleanTooltipValue {
    type: "boolean";
    value: boolean;
}

export type TooltipValue =
    | INumericTooltipValue
    | ILocationTooltipValue
    | IBooleanTooltipValue;
